module.exports = __webpack_public_path__ + "img/logofooter.204a2916.png";